import { ChartColors } from "../../core/config/chart.config";

export const ChartLegends = {
    activeAuthors: [
        { 
            key: 'Active Authors', 
            definition: 'Number of unique authors who have submitted within the past 5 years' 
        }
    ],

    poolProgression: [
        { 
            key: 'New Authors', 
            definition: ' Number of unique authors who are submitting for the first time' 
        },        
        { 
            key: 'Reactivated', 
            definition: 'Number of unique authors who have submitted again after a five or more year gap since their last submission' 
        }
    ],

    submittedPublished: [
        { 
            key: 'Submitted Articles', 
            definition: 'Number of Submitted manuscript.' 
        },
        { 
            key: 'Published Articles', 
            definition: 'Number of Published manuscripts.' 
        }
    ],

    submittedPublishedAvg: [
        { 
            key: 'Submitting Authors', 
            definition: 'Number of authors who have submitted manuscripts in a given month'
        },
        {
            key: 'Publishing Authors', 
            definition: 'Number of authors who have published manuscripts in a given month' 
        }
    ],
    submissions: [
        { 
            key: 'More Than 2', 
            definition: `In last 5 years, % of author pool that had 2+ submissions
= # of active authors (authors that submitted in last 5 years) with 2+ submissions / Author Pool (authors that submitted in last 5 years).` 
        },
        { 
            key: 'More Than 5', 
            definition: `In last 5 years, % of author pool that had 5+ submissions
= # of active authors (authors that submitted in last 5 years) with 5+ submissions / Author Pool (authors that submitted in last 5 years).` 
        },
        { 
            key: 'More Than 10', 
            definition: `In last 5 years, % of author pool that had 10+ submissions
= # of active authors (authors that submitted in last 5 years) with 10+ submissions / Author Pool (authors that submitted in last 5 years).` 
        }
    ],

    transfers: [        
        { 
            key: 'Author Retention Rate', 
            definition: '(Active Authors at End of Period − New Authors Acquired) / Active Authors at Start of Period.' 
        }
    ],

    marketingOptin: [
        { 
            key: 'Marketing Opt-in Count', 
            definition: '# of profiles currently opted in for marketing email messages.' 
        }
    ],
    emailMetrics: [
            { key: 'Sent', definition: 'The total number of emails sent via the AIPP Dotdigital account' },
            { key: 'Delivered', definition: 'Number of emails successfully delivered via the AIPP Dotdigital account' },
            { key: 'Unique Opened', definition: 'Number of unique email addresses that opened the emails' },
            { key: 'Unique Clicked', definition: 'Total number of link clicks for the AIPP Dotdigital email campaigns' }            
    ],
    
    emailEffectiveness: [
            { key: 'Sent', definition: 'The total number of emails sent via the AIPP Dotdigital account' },
            { key: 'Delivered', definition: 'Number of emails successfully delivered via the AIPP Dotdigital account' },
            { key: 'Unique Opened', definition: 'Number of unique email addresses that opened the emails' },
            { key: 'Unique Clicked', definition: 'Total number of link clicks for the AIPP Dotdigital email campaigns' }
        ],

    emailReadershipRate: [
        { key: 'Unique Open Rate', definition: 'Percentage of delivered emails that were opened' },        
        { key: 'Unique CTOR', definition: 'Percentage of unique clicks compared to unique opens for the AIPP Dotdigital email campaigns' },
        { key: 'Unique CTR', definition: 'The percentage of recipients who clicked a link out of the total emails sent for the AIPP Dotdigital campaigns' }
    ],

    emailRejectionRate: [
        { key: 'Bounce Rate', definition: 'The percentage of emails that were undeliverable and returned to the sender for the AIPP Dotdigital campaings, inculding both permanent and temporary failures. ' },
        { key: 'Unsubscribe Rate', definition: 'Percentage of delivered emails that resulted in recipients unsubscribing' }
    ],

    submissionsCount: [
        { 
            key: 'One Submission', 
            definition: 'Number of authors who have submitted one article in a given month' 
        },
        { 
            key: 'Two Submissions', 
            definition: 'Number of authors who have submitted two articles in a given month' 
        },
        { 
            key: 'Three Submissions', 
            definition: 'Number of authors who have submitted three articles in a given month' 
        },
        { 
            key: 'Four Submissions', 
            definition: 'Number of authors who have submitted four articles in a given month' 
        },
        { 
            key: 'Five+ Submissions', 
            definition: 'Number of authors who have submitted five or more articles in a given month' 
        }
    ],
    performance: [
        { 
          key: 'Sent', 
          name: 'Sent',
          color: ChartColors.primary,
          definition: 'Total number of emails sent in the campaign.'
        },
        { 
          key: 'Delivered', 
          name: 'Delivered',
          color: ChartColors.secondary,
          definition: 'Number of emails successfully delivered to recipients.'
        },
        { 
          key: 'Opened', 
          name: 'Opened',
          color: ChartColors.tertiary,
          definition: 'Number of delivered emails that were opened by recipients.'
        },
        { 
          key: 'Clicked', 
          name: 'Clicked',
          color: ChartColors.quaternary,
          definition: 'Number of emails where recipients clicked on at least one link.'
        },
        { 
          key: 'Bounced', 
          name: 'Bounced',
          color: ChartColors.quinary,
          definition: 'Number of emails that could not be delivered to the recipient ( Hard Bounce + Soft Bounce ) '
        },
        { 
          key: 'Unsubscribes', 
          name: 'Unsubscribes',
          color: ChartColors.senary,
          definition: 'Number of recipients who unsubscribed after receiving the email.'
        }
      ],
    performanceRate: [
      { 
        key: 'Open Rate', 
        name: 'Open Rate',
        color: ChartColors.primary,
        definition: 'Percentage of delivered emails that were opened by recipients.'
      },
      { 
        key: 'CTOR', 
        name: 'Click to Open Rate',
        color: ChartColors.secondary,
        definition: 'Percentage of opened emails where recipients clicked on at least one link.'
      },
      { 
        key: 'CTR', 
        name: 'Click Through Rate',
        color: ChartColors.tertiary,
        definition: 'Percentage of delivered emails where recipients clicked on at least one link.'
      },
      { 
        key: 'Unsubscribe Rate', 
        name: 'Unsubscribe Rate',
        color: ChartColors.quaternary,
        definition: 'Percentage of delivered emails that resulted in recipients unsubscribing.'
      },
      { 
        key: 'Bounce Rate', 
        name: 'Bounce Rate',
        color: ChartColors.quinary,
        definition: 'Percentage of emails that could not be delivered to the recipient ( Hard Bounce + Soft Bounce ) '
      }
    ]
};

 